import { AnyChart } from '@d3fc/d3fc-chart';
import {
    postfixNumber,
    postfixNumberWithFixedPrecision,
} from '@instinet-analytics/core-lib';

export function renderXAxis(chart: AnyChart, maxX: number) {
    chart.xTickFormat((d: number) => {
        const maxUnit = postfixNumber(maxX).slice(-1);
        return postfixNumberWithFixedPrecision(d, 1, maxUnit);
    });
}
